import {
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  // TablePagination,
} from "@mui/material";
import { TIdForCTM, TTableColumn } from "../../types";
import TableHeadRow from "./tableHeadMaterial";
import CustomTableRow from "./tableRowMaterial";
import { Fragment, useState } from "react";
import { RowsPerPageEnum } from "../../displayColumnsConfig";

export type TCustomTableProps<T extends TIdForCTM> = {
  list: T[];
  columns: TTableColumn[];
  page?: number;
  rowsPerPage?: number;
  tooltip?: string;
  linkTo?: string;
  count?: number;
  // handleChangeRowsPerPage: (e: any) => void;
  // handleChangePage: (e: any, page: any) => void;
  localPagination?: boolean;
  onClick?: (e: React.BaseSyntheticEvent) => void;
  groupBy?: string; // column name to group output by
  groupTitle?: (row: T) => string; // returns group title (usually formatted column content)
  expandableRow?: boolean; // can the rows be expanded. It will override onClick
  expandedRowFormat?: (row: any) => JSX.Element;
};

function CustomTableMaterial<T extends TIdForCTM>(props: TCustomTableProps<T>) {
  const {
    list,
    page,
    rowsPerPage,
    localPagination,
    columns,
    tooltip,
    // handleChangePage,
    // handleChangeRowsPerPage,
    linkTo,
    onClick,
    groupBy,
    groupTitle,
    expandableRow,
    expandedRowFormat,
  } = props;

  const [openedRow, setOpenedRow] = useState(-1);

  const dataToShow = !localPagination
    ? list
    : list.slice(
        (page || 0) * (rowsPerPage || RowsPerPageEnum.ALL),
        (page || 0) * (rowsPerPage || RowsPerPageEnum.ALL) +
          (rowsPerPage || RowsPerPageEnum.ALL),
      );
  let prevGroupByValue = "";

  // supply expandable columns headers with additional cell
  const colsWithExpandableCell = columns
    .map((c) => {
      return c.expandable ? [c, { id: "9999", label: "" }] : c;
    })
    .flat();

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeadRow columns={colsWithExpandableCell} />
        </TableHead>
        <TableBody>
          {dataToShow.map((row) => {
            let breakRow: JSX.Element | null = null;
            if (groupBy && (row as any)[groupBy] !== prevGroupByValue) {
              prevGroupByValue = (row as any)[groupBy];
              breakRow = (
                <TableRow key={"br" + row.id}>
                  <TableCell
                    key={"brc" + row.id}
                    sx={{ fontSize: "larger", backgroundColor: "#1833451c" }}
                    colSpan={
                      columns.length +
                      columns.filter((c) => c.expandable).length
                    }
                    dangerouslySetInnerHTML={{
                      __html: groupTitle ? groupTitle(row) : "",
                    }}
                  ></TableCell>
                </TableRow>
              );
            } else {
              breakRow = null;
            }
            return (
              <Fragment key={row.id}>
                {breakRow}
                <CustomTableRow
                  key={row.id}
                  component={typeof linkTo != "undefined" ? Link : undefined}
                  linkTo={
                    typeof linkTo != "undefined" ? linkTo! + row.id : undefined
                  }
                  tooltip={tooltip}
                  row={row}
                  columns={columns}
                  onClick={(e) => {
                    onClick
                      ? onClick({ ...e, target: { rowId: row.id } })
                      : undefined;
                  }}
                  expandableRow={expandableRow}
                  expandedRowFormat={expandedRowFormat}
                  openedRow={openedRow}
                  setOpenedRow={setOpenedRow}
                />
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
      {/* <TablePagination
        rowsPerPageOptions={rowsPerPage}
        component="div"
        count={props.count || list.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={() => {}}
        onRowsPerPageChange={() => {}}
      /> */}
    </Paper>
  );
}

export default CustomTableMaterial;
